// ENUMS #############################################################
export enum LanguageEnum {
	ENGLISH = 'en',
	GERMAN = 'de'
}

export enum LocaleEnum {
	/*
	 * Although the English variant preferably used in this app is AE, the English
	 * locale set here is BE. Reason (probably) is the desired short date format.
	 * For example, the desired English numeric short format is dd/MM/YYYY, but
	 * is M/d/YYYY by default and by 'en-us'.
	 */
	ENGLISH = 'en-gb',
	GERMAN = 'de-de'
}

// INTERFACES ########################################################
export interface ILanguageSelector {
	shortCode: LanguageEnum;
	localName: string;
	flag: string;
}

export interface ITranslationFile {
	[ key: string ]: any;
}


// TYPES #############################################################
export type LanguageDateFormat = {
	[key in LanguageEnum]: string;
};

export type LanguagesSupportedType = { [keyof in LanguageEnum]: string; };


// CONST #############################################################
export const LANGUAGE_LOCAL_NAME = {
	[ LanguageEnum.ENGLISH ]: 'English',
	[ LanguageEnum.GERMAN ]: 'Deutsch'
};

